import PropTypes from "prop-types";

const propTypes = {
  direction: PropTypes.oneOf(["left", "right"]),
  position: PropTypes.oneOf(["icon-left", "icon-right"])
};

export default propTypes;
